var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adsuccess"},[_c('div',{staticClass:"ad",on:{"click":_vm.toLink}},[_c('img',{attrs:{"src":require("../../../public/images/200G.png")}}),_c('el-button',{staticClass:"btn-submit"},[_vm._v("点 击 立 即 领 取")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }